import {DataARTransactionItemModel} from '../../../models/accountsReceivable/data-ar-transaction-item.model';

export class InsuranceTransactionItemsModel {
  InsuranceName: string;
  PatientInsuranceID: string;
  dataARTransactionItems: DataARTransactionItemModel[];
  PatientInsurancePrimary: boolean = false;
  InsuranceStartDate: Date;
  InsuranceEndDate: Date;
}
